import type { AppError, AsyncResult } from '@shared/utils';
import { ok } from '@shared/utils';
import { PackageBootstrap } from '@shared/core';
import type { PackageResourceConfig } from '@shared/core';
import type { RuntimeKind } from '@shared/core';
import type { TelehealthEnvironmentConfig } from '../../config/interfaces/TelehealthEnvironmentConfig';
import { Telehealth } from '../../classes/Telehealth';

/**
 * @group Bootstrap
 *
 * @summary
 * <blockquote>Bootstrap definition for `@shared/telehealth` — configures the Telehealth
 * runtime with the registered adapter.</blockquote>
 *
 * @example
 * ```typescript
 * import { TelehealthPackageBootstrap } from '@shared/telehealth';
 *
 * const telehealthEntry = {
 *   definition: new TelehealthPackageBootstrap('server'),
 *   config: telehealthResourceConfig,
 * };
 * ```
 */
export class TelehealthPackageBootstrap extends PackageBootstrap<TelehealthEnvironmentConfig> {
  readonly packageId = '@shared/telehealth';

  constructor(public readonly runtimeKind: RuntimeKind) {
    super();
  }

  async configureRuntime(
    config: PackageResourceConfig<TelehealthEnvironmentConfig>
  ): AsyncResult<void, AppError> {
    Telehealth.configureRuntime(config);
    return ok(undefined);
  }
}
